import { useState } from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  min?: number;
  max?: number;
  className?: string;
  id?: string;
  disabled?: boolean;
  'aria-label'?: string;
}

export function FormattedNumberInput({ value, onChange, min, max, className, ...props }: Props) {
  const [focused, setFocused] = useState(false);

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const raw = event.target.value.replace(/[^\d]/g, '');
    if (raw === '') {
      onChange('');
      return;
    }
    const num = Number(raw);
    if (min !== undefined && num < min) return;
    if (max !== undefined && num > max) return;
    onChange(raw);
  }

  const displayValue = focused || value === '' ? value : Number(value).toLocaleString('zh-CN');

  return (
    <input
      {...props}
      type="text"
      inputMode="numeric"
      className={['formatted-number-input', className].filter(Boolean).join(' ')}
      value={displayValue}
      onChange={handleChange}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
}
